

























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
class StandartModal extends Vue {
  @Prop({ type: String, required: true }) id!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) badgeId!: string;
  @Prop({ type: String, default: "xl" }) size!: string;
  @Prop({ type: Boolean, default: false }) centered!: boolean;
  @Prop({ type: Boolean, default: false }) noCloseOnBackdrop!: boolean;
  @Prop({ type: Boolean, default: false }) hideHeader!: boolean;
  @Prop({ type: Boolean, default: true }) hideFooter!: boolean;
  @Prop({ type: Boolean, default: false }) scrollable!: boolean;
  @Prop({ type: Boolean, default: false }) lazy!: boolean;
  @Prop({ type: [String, Array, Object], default: "" })
  contentClass!: string | Array<unknown> | Record<string, unknown>;
  @Prop({ type: [String, Array, Object], default: "" })
  modalClass!: string | Array<unknown> | Record<string, unknown>;
  @Prop({ type: [String, Array, Object], default: "" })
  bodyClass!: string | Array<unknown> | Record<string, unknown>;
  @Prop({ type: String, default: "" }) headerBgVariant!: string;
  @Prop({ type: String, default: "" }) bodyBgVariant!: string;
  @Prop({ type: String, default: "" }) footerBgVariant!: string;
  @Prop({ type: Boolean, default: undefined })
  value!: boolean | undefined;
}
export default StandartModal;
